export default class MainHistory {
    constructor() {
        this.section = document.querySelector(".no-main-history");
        if (!this.section) return;

        this.init();
    }

    init() {
        this.wrap = this.section.querySelector(".no-main-history__inner");
        this.yearWrap = this.section.querySelector(
            ".no-main-history__year-wrap"
        );
        this.yearLeft = this.section.querySelector(
            ".no-main-history__typo-first"
        );
        this.yearRight = this.section.querySelector(
            ".no-main-history__typo-last"
        );
        this.images = this.section.querySelectorAll(".no-main-history__image");

        this.initYearMotion();
        this.initImagesMotion();
    }

    initYearMotion() {
        if (!this.yearWrap) return;

        // Desktop (768px 이상)
        ScrollTrigger.matchMedia({
            "(min-width: 1025px)": () => {
                gsap.fromTo(
                    this.yearLeft,
                    {
                        xPercent: 35,
                        force3D: true,
                    },
                    {
                        xPercent: -20,
                        ease: "none",
                        force3D: true,
                        scrollTrigger: {
                            trigger: this.wrap,
                            start: "top bottom",
                            end: "center center",
                            scrub: 0.5,
                        },
                    }
                );

                gsap.fromTo(
                    this.yearRight,
                    {
                        xPercent: -35,
                        force3D: true,
                    },
                    {
                        xPercent: 20,
                        ease: "none",
                        force3D: true,
                        scrollTrigger: {
                            trigger: this.wrap,
                            start: "top bottom",
                            end: "center center",
                            scrub: 0.5,
                        },
                    }
                );
            },
            // Mobile (1024px 이하)
            "(max-width: 1024px)": () => {
                gsap.fromTo(
                    this.yearLeft,
                    {
                        yPercent: -75,
                        force3D: true,
                    },
                    {
                        yPercent: -25,
                        ease: "none",
                        force3D: true,
                        scrollTrigger: {
                            trigger: this.wrap,
                            start: "top bottom",
                            end: "center center",
                            scrub: 0.5,
                        },
                    }
                );

                gsap.fromTo(
                    this.yearRight,
                    {
                        yPercent: 50,
                        force3D: true,
                    },
                    {
                        yPercent: -25,
                        ease: "none",
                        force3D: true,
                        scrollTrigger: {
                            trigger: this.wrap,
                            start: "top bottom",
                            end: "center center",
                            scrub: 0.5,
                        },
                    }
                );
            },
        });
    }

    initImagesMotion() {
        if (!this.images.length) return;

        const imgElement = this.images[0].querySelector("img");
        if (!imgElement) return;

        let currentIdx = 1;

        // 이미지 전환 애니메이션 (RAF 최적화)
        // 이미지가 1~11.jpg까지 있으므로 11까지 표시 후 1로 리셋
        gsap.to(
            {},
            {
                duration: 0.25,
                repeat: -1,
                ease: "none",
                onRepeat: () => {
                    currentIdx = currentIdx >= 11 ? 1 : currentIdx + 1;
                    const basePath = imgElement.dataset.basePath;
                    imgElement.src = `${basePath}${currentIdx}.jpg?v=251212`;
                    imgElement.dataset.idx = currentIdx;
                },
            }
        );

        // 스크롤 시 이미지 스케일 애니메이션
        gsap.fromTo(
            this.images[0],
            {
                scale: 1.2,
                force3D: true,
            },
            {
                scale: 0.8,
                ease: "none",
                force3D: true,
                scrollTrigger: {
                    trigger: this.wrap,
                    start: "top bottom",
                    end: "bottom center",
                    scrub: 0.5,
                },
            }
        );
    }
}
